import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { performRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';
import type { PollResponse } from './types.tsx';

const pollWithHeaders = (url: string): Observable<PollResponse> => {
	return Observable.fromPromise(performRequest(url, { method: 'GET' })).flatMap((response) =>
		Observable.fromPromise(response.json()).map((data) => ({
			...data,
			searchMode: response.headers.get('Atl-Issue-Search-Mode'),
		})),
	);
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (projectKey: string, projectStateHash: string): Observable<PollResponse> => {
	const params = new URLSearchParams();

	if (projectStateHash) {
		params.set('projectStateHash', projectStateHash);
	}
	params.set('operation', 'fetchQueuesPoll');

	const queryString = params.size ? `?${params.toString()}` : '';

	const url = `/rest/servicedesk/1/servicedesk/${projectKey}/queues/poll${queryString}`;

	if (fg('jsm-corcap-3722-pass-search-mode')) {
		return pollWithHeaders(url);
	}

	return fetchJson$(url, {
		method: 'GET',
	});
};
